import { css } from '@emotion/react';

const dailyPriceStyles = css`
    .daily-price-wrapper {
        & > * {
            margin: 0;
        }
    }

    .date {
        font-size: 0.8em;
    }

    .price {
        font-size: 1.2em;
        font-weight: bold;
        padding-top: 2px;
    }

    .price-change {
        font-size: 0.8em;
        font-weight: bold;
        color: green;

        &.negative {
            color: red;
        }

        .icon {
            margin-right: 3px;
        }
    }
`;

export const themeDailyPriceStyles = css`
    .daily-price-wrapper {
        & > * {
            margin: 0;
        }
    }

    .date {
        font-size: var(--body-small-fontSize);
    }

    .price {
        font-size: var(--body-large-fontSize);
        font-weight: bold;
        padding-top: 2px;
    }

    .price-change {
        font-size: var(--body-small-fontSize);
        font-weight: bold;
        color: var(--color-green);

        &.negative {
            color: var(--color-red);
        }

        .icon {
            margin-right: 3px;
        }
    }
`;

export default dailyPriceStyles;
